/*
 * @Description:
 * @Author: muqingkun
 * @Date: 2023-07-28 15:45:58
 * @LastEditTime: 2024-05-08 17:09:49
 * @LastEditors: Please set LastEditors
 * @Reference:
 */
import { defineStore } from 'pinia';
import { baseType, DictList } from './types';
import { store } from '@/store';
import { getDict } from '@/api/common';
import { storageLocal } from '@pureadmin/utils';
import { message as elMessage } from '@/utils/message';
import { $t } from '@/plugins/i18n';

export const useBaseStore = defineStore({
  id: 'pure-base',
  state: (): baseType => ({
    dictList: []
  }),
  getters: {
    getDictList(): DictList[] | [] {
      return this.dictList;
    }
  },
  actions: {
    /** 存储字典 */
    SET_DICT(dictList: Array<DictList>) {
      this.dictList = dictList;
    },
    /** 获取数据字典 */
    async setDictList(reqData: object) {
      return new Promise((resolve, reject) => {
        getDict(reqData)
          .then(res => {
            if (res) {
              this.SET_DICT(res.data);
              if (Array.isArray(res.data)) {
                const resData = res.data || [];
                storageLocal().setItem('dict-map', resData);
              } else {
                elMessage('未获取到数据字典', { type: 'error' });
              }
              resolve(res);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    }
  }
});

export function useBaseStoreHook() {
  return useBaseStore(store);
}
